import ErrorBoundary from './ErrorBoundary';

export type { ErrorBoundaryProps, ErrorBoundaryState } from './interface';
export default ErrorBoundary;
